/* Copyright 2012-2015 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the events associated with it. This
 * information is used in order to dispatch the correct events to the peer model. This is also used
 * to map events to actions registered with the action service.
 */

define([
    "../constants/TypeConstants",

    // All containers:
    "../widgets/Toolstrip",
    "../widgets/QAB",
    "../widgets/QAGroup",
    "../widgets/TabGroup",
    "../widgets/Tab",
    "../widgets/Section",
    "../widgets/Panel",
    "../widgets/Column",
    "../menu/PopupListPanel",
    "../widgets/Footer",
    "../widgets/FooterCell",
    // Gallery:
    "../widgets/gallery/Gallery",
    "../widgets/gallery/GalleryPopup",
    "../widgets/gallery/GalleryPanel",
    "../widgets/gallery/GalleryCategory",

    // Different types of buttons:
    "../form/PushButton",
    "../form/DropDownButton",
    "../form/SplitButton",
    "../form/ToggleButton",
    "../form/ColorPickerButton",
    "../form/GridPickerButton",

// QAB Controls:
    "../qab/QABPushButton",
    "../qab/QABDropDownButton",
    "../qab/QABSplitButton",
    "../qab/QABToggleButton",
    "../qab/QABToggleSplitButton",

// Special Controls:
    "../widgets/qabcontrols/QABFloatingPaneDock",
    "../form/ToggleSplitButton",

// Popup list:
    "../menu/PopupList",
    "../menu/ListItem",
    "../menu/ListItemWithPopup",
    "../menu/ListItemWithCheckBox",
    "../menu/ListItemWithTextField",
    "../menu/ListItemWithRadioButton",
    "../menu/PopupListSeparator",
    "../menu/PopupListHeader",
// Other controls:
    "../form/ComboBox",
    "../form/ListBox",
    "../form/Label",
    "../widgets/EmptyControl",
    "../form/TextField",
    "../form/TextArea",
    "../form/Spinner",
    "../widgets/HorizontalSlider",
    "../form/RadioButton",
    "../form/CheckBox",
// Wrappers:
    "../widgets/ToolbarWrapper",
    "../widgets/MenubarWrapper",
// Gallery:
    "../widgets/gallery/GalleryItem",
    "../widgets/gallery/ToggleGalleryItem"
], function (TypeConstants, Toolstrip, QAB, QAGroup, TabGroup, Tab, Section, Panel, Column,
             PopupListPanel, Footer, FooterCell, Gallery, GalleryPopup, GalleryPanel, GalleryCategory, PushButton, DropDownButton,
             SplitButton, ToggleButton, ColorPickerButton, GridPickerButton, QABPushButton, QABDropDownButton, QABSplitButton, QABToggleButton,
             QABToggleSplitButton,
             QABFloatingPaneDock, ToggleSplitButton, PopupList, ListItem, ListItemWithPopup, ListItemWithCheckBox,
             ListItemWithTextField, ListItemWithRadioButton, PopupListSeparator, PopupListHeader, ComboBox, ListBox,
             Label, EmptyControl, TextField, TextArea, Spinner, HorizontalSlider, RadioButton, CheckBox, ToolbarWrapper,
             MenubarWrapper, GalleryItem, ToggleGalleryItem) {
    var hash = {};

    hash[TypeConstants.TOOLSTRIP] = Toolstrip;
    hash[TypeConstants.QAB] = QAB;
    hash[TypeConstants.QA_GROUP] = QAGroup;
    hash[TypeConstants.TAB_GROUP] = TabGroup;
    hash[TypeConstants.TAB] = Tab;
    hash[TypeConstants.SECTION] = Section;
    hash[TypeConstants.PANEL] = Panel;
    hash[TypeConstants.POPUP_LIST_PANEL] = PopupListPanel;
    hash[TypeConstants.COLUMN] = Column;
    hash[TypeConstants.GALLERY] = Gallery;
    hash[TypeConstants.GALLERY_POPUP] = GalleryPopup;
    hash[TypeConstants.GALLERY_PANEL] = GalleryPanel;
    hash[TypeConstants.GALLERY_CATEGORY] = GalleryCategory;
    hash[TypeConstants.GALLERY_FAVORITE_CATEGORY] = GalleryCategory;
    hash[TypeConstants.FOOTER] = Footer;
    hash[TypeConstants.FOOTER_CELL] = FooterCell;

    hash[TypeConstants.PUSH_BUTTON] = PushButton;
    hash[TypeConstants.DROP_DOWN_BUTTON] = DropDownButton;
    hash[TypeConstants.SPLIT_BUTTON] = SplitButton;
    hash[TypeConstants.TOGGLE_BUTTON] = ToggleButton;
    hash[TypeConstants.COLOR_PICKER_BUTTON] = ColorPickerButton;
    hash[TypeConstants.GRID_PICKER_BUTTON] = GridPickerButton;

    hash[TypeConstants.QAB_PUSH_BUTTON] = QABPushButton;
    hash[TypeConstants.QAB_DROP_DOWN_BUTTON] = QABDropDownButton;
    hash[TypeConstants.QAB_SPLIT_BUTTON] = QABSplitButton;
    hash[TypeConstants.QAB_TOGGLE_BUTTON] = QABToggleButton;
    hash[TypeConstants.QAB_TOGGLE_SPLIT_BUTTON] = QABToggleSplitButton;
    hash[TypeConstants.QAB_FLOATING_PANE_DOCK] = QABFloatingPaneDock;
    hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = ToggleSplitButton;

    hash[TypeConstants.POPUP_LIST] = PopupList;
    hash[TypeConstants.LIST_ITEM] = ListItem;
    hash[TypeConstants.LIST_ITEM_WITH_POPUP] = ListItemWithPopup;
    hash[TypeConstants.LIST_ITEM_WITH_CHECKBOX] = ListItemWithCheckBox;
    hash[TypeConstants.LIST_ITEM_WITH_TEXTFIELD] = ListItemWithTextField;
    hash[TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON] = ListItemWithRadioButton;
    hash[TypeConstants.POPUP_LIST_SEPARATOR] = PopupListSeparator;
    hash[TypeConstants.POPUP_LIST_HEADER] = PopupListHeader;
    hash[TypeConstants.COMBO_BOX] = ComboBox;
    hash[TypeConstants.LIST] = ListBox;
    hash[TypeConstants.LABEL] = Label;
    hash[TypeConstants.EMPTY_CONTROL] = EmptyControl;
    hash[TypeConstants.TEXT_FIELD] = TextField;
    hash[TypeConstants.TEXT_AREA] = TextArea;
    hash[TypeConstants.SPINNER] = Spinner;
    hash[TypeConstants.HORIZONTAL_SLIDER] = HorizontalSlider;
    hash[TypeConstants.RADIO_BUTTON] = RadioButton;
    hash[TypeConstants.CHECK_BOX] = CheckBox;
    hash[TypeConstants.MENUBAR_WRAPPER] = MenubarWrapper;
    hash[TypeConstants.TOOLBAR_WRAPPER] = ToolbarWrapper;
    hash[TypeConstants.GALLERY_ITEM] = GalleryItem;
    hash[TypeConstants.TOGGLE_GALLERY_ITEM] = ToggleGalleryItem;

    return hash;
});
